import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { map } from "lodash";
import Select from "react-select";

import Config from "config";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Table,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import TableComponent from "components/Common/TableComponent";
import OperationList from "components/Common/OperationListHm";
import DocumentHm from "components/Common/DocumentPmeHm";
import DocumentFusionHm from "components/Common/DocumentFusionHm";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import SectionCard from "components/Common/SectionCard";
import SouscriptionFinaliseesListHm from "components/Common/SouscriptionFinaliseesListHm";
import InvestissementListHm from "components/Common/InvestissementListHm";

const investissEdit = () => {
  const api = Config.backOffice.apiName;
  const backUrl = Config.backOffice.url;
  let { id } = useParams();
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("auth_token");
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [wait, setWait] = useState(1000);
  const toggleModal = () => setModal(!modal);
  const [investData, setInvestData] = useState([]);
  const colStyle = { width: "10em", whiteSpace: "nowrap" };

  //meta title
  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage

  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Investissements | Edit";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    const navStyleClient = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
      textAlign: "left",
    };

    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            onClick={() => handleTabClick("details")}
          >
            {!loading ? (
              "Détails investissements"
            ) : (
              <span
                className="placeholder col-3"
                style={{ height: "1em" }}
              ></span>
            )}
          </NavLink>
        </NavItem>
      </Nav>
    );
  };
  /*************************   PME  *******************************/
  const [pme, setPmeData] = useState({ data: [] });
  const [selectedPme, setSelectedPme] = useState("");
  const handlePmeChange = (e) => {
    setSelectedPme(e);
  };
  const getPme = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investissements/pmes`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pme) => {
          setPmeData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPmeOptions = () => {
    return [
      {
        options: pme.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END PME *******************************/
  /*************************   Classe immobilisation  *******************************/
  const [classe, setClasseData] = useState({ data: [] });
  const [selectedClasse, setSelectedClasse] = useState("");
  const handleClasseChange = (e) => {
    setSelectedClasse(e);
  };
  const getClasse = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investissements/classe_immobilisations`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((pme) => {
          setClasseData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderClasseOptions = () => {
    return [
      {
        options: classe.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END Classe *******************************/
  /*************************   Tranche  *******************************/
  const [tranche, setTrancheData] = useState({ data: [] });
  const [selectedTranche, setSelectedTranche] = useState("");
  const handleTrancheChange = (e) => {
    setSelectedTranche(e);
  };
  const getTranche = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investissements/tranchs?${id}&pme_id=${
          selectedPme?.value || ""
        }&tranch_id=${selectedTranche?.value || ""}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((pme) => {
          setTrancheData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTrancheOptions = () => {
    return [
      {
        options: tranche.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END Tranche *******************************/
  /*************************   Code  *******************************/
  const [code, setCodeData] = useState({ data: [] });
  const [selectedCode, setSelectedCode] = useState("");
  const handleCodeChange = (e) => {
    setSelectedCode(e);
  };
  const getCode = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investissements/codes_investissements`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((pme) => {
          setCodeData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderCodeOptions = () => {
    return [
      {
        options: code.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END Code *******************************/
  /*************************   Direction  *******************************/
  const [direction, setDirectionData] = useState({ data: [] });
  const [selectedDirection, setSelectedDirection] = useState("");
  const handleDirectionChange = (e) => {
    setSelectedDirection(e);
  };
  const getDirection = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investissements/partenaires3`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pme) => {
          setDirectionData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderDirectionOptions = () => {
    return [
      {
        options: direction.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END Direction *******************************/
  /****Numéro *****/
  const [selectedNumero, setSelectedNumero] = useState("");
  const handleNumeroChange = (e) => {
    setSelectedNumero(e.target.value);
  };
  /******End Numéro */
  /****designation Courte *****/
  const [selectedDesignationCourte, setSelectedDesignationCourte] =
    useState("");
  const handleDesignationCourteChange = (e) => {
    setSelectedDesignationCourte(e.target.value);
  };
  /******End designation Courte */
  /****designation Op *****/
  const [selectedDesignationOp, setSelectedDesignationOp] = useState("");
  const handleDesignationOpChange = (e) => {
    setSelectedDesignationOp(e.target.value);
  };
  /******End designation Op */
  /****Honoraire 1 *****/
  const [selectedHonoraire1, setSelectedHonoraire1] = useState("");
  const handleHonoraire1Change = (e) => {
    setSelectedHonoraire1(e.target.value);
  };
  /******End Honoraire 1 */
  /****Honoraire 2 *****/
  const [selectedHonoraire2, setSelectedHonoraire2] = useState("");
  const handleHonoraire2Change = (e) => {
    setSelectedHonoraire2(e.target.value);
  };
  /******End Honoraire 2 */
  /****Honoraire 3 *****/
  const [selectedHonoraire3, setSelectedHonoraire3] = useState("");
  const handleHonoraire3Change = (e) => {
    setSelectedHonoraire3(e.target.value);
  };
  /******End Honoraire 3 */
  /****Taux loyer *****/
  const [selectedTauxLoyer, setSelectedTauxLoyer] = useState("");
  const handleTauxLoyerChange = (e) => {
    setSelectedTauxLoyer(e.target.value);
  };
  /******End Taux Loyer */
  /****Taux service *****/
  const [selectedTauxService, setSelectedTauxService] = useState("");
  const handleTauxServiceChange = (e) => {
    setSelectedTauxService(e.target.value);
  };
  /******End Taux Loyer */
  /*************************   Statut  *******************************/
  const [statut, setStatutData] = useState({ data: [] });
  const [selectedStatut, setSelectedStatut] = useState("");
  const handleStatutChange = (e) => {
    setSelectedStatut(e);
  };
  const getStatut = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investissements/statuts_investissements`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((pme) => {
          setStatutData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderStatutOptions = () => {
    return [
      {
        options: statut.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END Statut *******************************/
  /*************************   PartenaireIndu  *******************************/
  const [partenaireIndu, setPartenaireInduData] = useState({ data: [] });
  const [selectedPartenaireIndu, setSelectedPartenaireIndu] = useState("");
  const handlePartenaireInduChange = (e) => {
    setSelectedPartenaireIndu(e);
  };
  const getPartenaireIndu = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investissements/partenaires3 `, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pme) => {
          setPartenaireInduData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPartenaireInduOptions = () => {
    return [
      {
        options: partenaireIndu.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END PartenaireIndu *******************************/
  // Exploitant
  const [exploitant, setExploitantData] = useState({ data: [] });
  const [selectedExploitant, setSelectedExploitant] = useState();
  const handleExploitantChange = (e) => {
    setSelectedExploitant(e);
  };
  const getExploitant = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investissements/partenaires2 `, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pme) => {
          setExploitantData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderExploitantOptions = () => {
    return [
      {
        options: exploitant.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  // Section
  const [selectedSection, setSelectedSection] = useState("");
  const handleSectionChange = (e) => {
    setSelectedSection(e.target.value);
  };

  // N° cadastre
  const [selectedCadastre, setSelectedCadastre] = useState("");
  const handleCadastreChange = (e) => {
    setSelectedCadastre(e.target.value);
  };

  // Contenance
  const [selectedContenance, setSelectedContenance] = useState("");
  const handleContenanceChange = (e) => {
    setSelectedContenance(e.target.value);
  };
  // Nature
  const [selectedNature, setSelectedNature] = useState("");
  const handleNatureChange = (e) => {
    setSelectedNature(e.target.value);
  };

  // Lieu-dit
  const [selectedLieuDit, setSelectedLieuDit] = useState("");
  const handleLieuDitChange = (e) => {
    setSelectedLieuDit(e.target.value);
  };

  // Adresse
  const [selectedAdresse, setSelectedAdresse] = useState("");
  const handleAdresseChange = (e) => {
    setSelectedAdresse(e.target.value);
  };

  // Code postal
  const [selectedCodePostal, setSelectedCodePostal] = useState("");
  const handleCodePostalChange = (e) => {
    setSelectedCodePostal(e.target.value);
  };

  // Commune
  const [selectedCommune, setSelectedCommune] = useState("");
  const handleCommuneChange = (e) => {
    setSelectedCommune(e.target.value);
  };

  // Date PV livraison
  const [selectedDateLivraison, setSelectedDateLivraison] = useState("");
  const handleDateLivraisonChange = (e) => {
    setSelectedDateLivraison(e.target.value);
  };

  // Montant (€)
  const [selectedMontant, setSelectedMontant] = useState("");
  const handleMontantChange = (e) => {
    setSelectedMontant(e.target.value);
  };

  // Prix unitaire (€)
  const [selectedPrixUnitaire, setSelectedPrixUnitaire] = useState("");
  const handlePrixUnitaireChange = (e) => {
    setSelectedPrixUnitaire(e.target.value);
  };

  // % rétrocession exploitant
  const [selectedPourcentageRetro, setSelectedPourcentageRetro] = useState("");
  const handlePourcentageRetroChange = (e) => {
    setSelectedPourcentageRetro(e.target.value);
  };

  // Rétrocession exploitant (€)
  const [selectedRetroExploitant, setSelectedRetroExploitant] = useState("");
  const handleRetroExploitantChange = (e) => {
    setSelectedRetroExploitant(e.target.value);
  };
  // Durée amortissement (mois)
  const [selectedDureeAmortissement, setSelectedDureeAmortissement] =
    useState("");
  const handleDureeAmortissementChange = (e) => {
    setSelectedDureeAmortissement(e.target.value);
  };

  // Agrément
  const [agrement, SetAgrementData] = useState({ data: [] });
  const [selectedAgrement, setSelectedAgrement] = useState();
  const handleAgrementChange = (e) => {
    setSelectedAgrement(e);
  };
  const getAgrement = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investissements/provenance_subventions `,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((pme) => {
          SetAgrementData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderAgrementOptions = () => {
    return [
      {
        options: agrement.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const OuiNon = {
    data: [
      { id: 1, label: "Oui" },
      { id: 2, label: "Non" },
    ],
  };
  const renderOuiNonOptions = () => {
    return [
      {
        options: OuiNon.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  // Subvention
  const [selectedSubvention, setSelectedSubvention] = useState();
  const handleSubventionChange = (e) => {
    setSelectedSubvention(e);
  };

  // Base éligible (€)
  const [selectedBaseEligible, setSelectedBaseEligible] = useState("");
  const handleBaseEligibleChange = (e) => {
    setSelectedBaseEligible(e.target.value);
  };
  // % réduction impôt
  const [
    selectedPourcentageReductionImpot,
    setSelectedPourcentageReductionImpot,
  ] = useState("");
  const handlePourcentageReductionImpotChange = (e) => {
    setSelectedPourcentageReductionImpot(e.target.value);
  };
  // Réduction impôt (€)
  const [selectedReductionImpot, setSelectedReductionImpot] = useState("");
  const handleReductionImpotChange = (e) => {
    setSelectedReductionImpot(e.target.value);
  };
  //****SHOW */
  const [showField, setShowFied] = useState("");
  const getShow = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investissements/show_fields?pme_id=${
          selectedPme?.value || ""
        }&statuts_investissments=${selectedStatut?.value || ""}&subvention2=${
          selectedSubvention?.value || ""
        }`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((reservation) => {
          setShowFied(reservation);
        });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    setLoading(true);
    const getData = async () => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/investissements/${id}/edit`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 403) {
          navigate(`${backUrl}/forbidden`);
        }
        if (response.status === 500) {
          navigate(`${backUrl}/error`);
        }
        if (response.status === 203) {
          navigate(`${backUrl}/error404`);
        }
        if (response.status === 401) {
          localStorage.removeItem("auth_token");
          localStorage.removeItem("authUser");
          localStorage.removeItem("sideBar");
          navigate(`${backUrl}/login`);
          window.location.reload(false);
        }
        // if (!response.ok) {
        //   localStorage.removeItem("auth_token");
        //   localStorage.removeItem("authUser");
        //   localStorage.removeItem("sideBar");
        //   history("/backoffice_test/login");
        //   window.location.reload(false);
        //   throw new Error(`Request failed with status: ${response.status}`);
        // }

        const investData = await response.json();
        setInvestData(investData);
        setSelectedPme(
          investData.detail_investissement?.[
            "Caractéristiques de l'investissement"
          ].PME
        );
        setSelectedClasse(
          investData.detail_investissement?.[
            "Caractéristiques de l'investissement"
          ]?.["Classe immobilisation"]
        );
        setSelectedTranche(
          investData.detail_investissement?.[
            "Caractéristiques de l'investissement"
          ]?.["Tranche"]
        );
        setSelectedCode(
          investData.detail_investissement?.[
            "Caractéristiques de l'investissement"
          ]?.["Code secteur"]
        );
        setSelectedDirection(
          investData.detail_investissement?.[
            "Caractéristiques de l'investissement"
          ]?.["Direction produit"]
        );
        setSelectedStatut(
          investData.detail_investissement?.[
            "Caractéristiques de l'investissement"
          ]?.["Statut"]
        );
        setSelectedNumero(
          investData.detail_investissement?.[
            "Caractéristiques de l'investissement"
          ]?.["Numéro"]
        );
        setSelectedPartenaireIndu(
          investData.detail_investissement?.["Description"]?.[
            "Partenaires industriels"
          ]
        );
        setSelectedHonoraire1(
          investData.detail_investissement?.["Honoraires"]?.["Honoraire 1"]
        );
        setSelectedHonoraire2(
          investData.detail_investissement?.["Honoraires"]?.["Honoraire 2"]
        );
        setSelectedHonoraire3(
          investData.detail_investissement?.["Honoraires"]?.["Honoraire 3"]
        );
        setSelectedTauxLoyer(
          investData.detail_investissement?.["Honoraires"]?.["Taux loyer"]
        );
        setSelectedTauxService(
          investData.detail_investissement?.["Honoraires"]?.["Taux service"]
        );
        setSelectedExploitant(
          investData.detail_investissement?.["Exploitation"]?.["Exploitant"]
        );

        setWait(0);
      } catch (error) {
        // Handle any other errors that might occur during the fetch
        console.error("Error fetching data:", error.message);
      }
    };

    const fetchData = async () => {
      try {
        await getData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    if (localStorage.getItem("key") === "true") {
      toast.success("Mise à jour réussie");
      localStorage.setItem("key", "false");
    }
  }, []);
  useEffect(() => {
    if (wait === 0) {
      setLoading(false);
    }
  }, [wait]);
  useEffect(() => {
    if (!loading) {
      getPme();
      getClasse();
      getTranche();
      getCode();
      getDirection();
      getStatut();
      getPartenaireIndu();
      getExploitant();
      getAgrement();
      getShow();
    }
  }, [loading]);
  useEffect(() => {
    if (!loading) {
      getTranche();
      getShow();
    }
  }, [selectedPme, selectedTranche]);
  useEffect(() => {
    if (!loading) {
      getShow();
    }
  }, [selectedStatut, selectedSubvention]);
  let linkState = { active: "" };

  if (activeTab == "details") {
    linkState.active = "details";
  } else if (activeTab == "contact") {
    linkState.active = "contact";
  } else {
    linkState.active = "details";
  }

  return (
    <React.Fragment>
      <div className="page-content" style={{ fontFamily: "sans-serif" }}>
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-0 card-title flex-grow-1"
                      style={{ fontWeight: "bold", display: "flex" }}
                    >
                      {!loading ? (
                        <>
                          <Link
                            to={`${backUrl}/investissements`}
                            style={{
                              color: "#3c88c8",
                              textDecoration: "underline !important",
                            }}
                          >
                            Investissements
                          </Link>{" "}
                        </>
                      ) : (
                        <span
                          className="placeholder col-3"
                          style={{ height: "1em" }}
                        ></span>
                      )}
                      <i className="bx bx-caret-right"></i>{" "}
                      {!loading ? (
                        investData.sil
                      ) : (
                        <>
                          <span
                            className="placeholder col-3"
                            style={{ height: "1em" }}
                          ></span>
                        </>
                      )}
                    </h5>
                  </div>

                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end">
                      {investData.can_edit ? (
                        <Link
                          to={`${backUrl}/investissements/${id}/edit`}
                          state={linkState}
                          className="btn btn-sm btn-info"
                        >
                          <i className="bx bx-edit-alt"></i>Modifier
                        </Link>
                      ) : null}
                      &nbsp; &nbsp;
                      {investData.can_destroy ? (
                        <Link to="#!" className="btn btn-sm btn-danger">
                          <i className="bx bx-trash-alt"></i>Supprimer
                        </Link>
                      ) : null}
                    </div>
                  </div>
                </CardBody>
                {CustomNavTabs()}
                <CardBody>
                  {activeTab === "details" && (
                    <div>
                      {!loading ? (
                        <>
                          <Row>
                            <Col sm="6">
                              {investData?.detail_investissement?.[
                                "Caractéristiques de l'investissement"
                              ] ? (
                                <Card className="mb-4">
                                  <CardTitle
                                    tag="h5"
                                    style={{ paddingLeft: "10px" }}
                                  >
                                    Caractéristiques de l'investissement
                                  </CardTitle>
                                  <CardBody>
                                    {Object.entries(
                                      investData?.detail_investissement?.[
                                        "Caractéristiques de l'investissement"
                                      ]
                                    ).map(([key, value], index) => (
                                      <Row className="mb-3" key={index}>
                                        {key == "PME" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i
                                                style={{
                                                  color: "#9d9c9c",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "8em",
                                                    whiteSpace: "nowrap",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  {key} :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col className="col-8">
                                              <Select
                                                defaultValue={selectedPme}
                                                onChange={handlePmeChange}
                                                options={renderPmeOptions()}
                                                isClearable={true}
                                                className="select2"
                                              />
                                            </Col>
                                          </>
                                        ) : key == "Classe immobilisation" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i
                                                style={{
                                                  color: "#9d9c9c",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "8em",
                                                    whiteSpace: "nowrap",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  {key}:
                                                </span>
                                              </i>
                                            </Col>
                                            <Col className="col-8">
                                              <Select
                                                defaultValue={selectedClasse}
                                                onChange={handleClasseChange}
                                                options={renderClasseOptions()}
                                                isClearable={true}
                                                className="select2"
                                              />
                                            </Col>
                                          </>
                                        ) : key == "Tranche" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i
                                                style={{
                                                  color: "#9d9c9c",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "8em",
                                                    whiteSpace: "nowrap",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  {key}:
                                                </span>
                                              </i>
                                            </Col>
                                            <Col className="col-8">
                                              <Select
                                                defaultValue={selectedTranche}
                                                onChange={handleTrancheChange}
                                                options={renderTrancheOptions()}
                                                isClearable={true}
                                                className="select2"
                                              />
                                            </Col>
                                          </>
                                        ) : key == "Direction produit" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i
                                                style={{
                                                  color: "#9d9c9c",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "8em",
                                                    whiteSpace: "nowrap",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  {key}:
                                                </span>
                                              </i>
                                            </Col>
                                            <Col className="col-8">
                                              <Select
                                                defaultValue={selectedDirection}
                                                onChange={handleDirectionChange}
                                                options={renderDirectionOptions()}
                                                isClearable={true}
                                                className="select2"
                                              />
                                            </Col>
                                          </>
                                        ) : key == "Code secteur" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i
                                                style={{
                                                  color: "#9d9c9c",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "8em",
                                                    whiteSpace: "nowrap",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  {key}:
                                                </span>
                                              </i>
                                            </Col>
                                            <Col className="col-8">
                                              <Select
                                                defaultValue={selectedCode}
                                                onChange={handleCodeChange}
                                                options={renderCodeOptions()}
                                                isClearable={true}
                                                className="select2"
                                              />
                                            </Col>
                                          </>
                                        ) : key == "Statut" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i
                                                style={{
                                                  color: "#9d9c9c",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "8em",
                                                    whiteSpace: "nowrap",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  {key}:
                                                </span>
                                              </i>
                                            </Col>
                                            <Col className="col-8">
                                              <Select
                                                defaultValue={selectedStatut}
                                                onChange={handleStatutChange}
                                                options={renderStatutOptions()}
                                                isClearable={true}
                                                className="select2"
                                              />
                                            </Col>
                                          </>
                                        ) : key == "Numéro" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i
                                                style={{
                                                  color: "#9d9c9c",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "8em",
                                                    whiteSpace: "nowrap",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  {key}:
                                                </span>
                                              </i>
                                            </Col>
                                            <Col className="col-8">
                                              <input
                                                className="form-control"
                                                defaultValue={selectedNumero}
                                                required
                                                onChange={handleNumeroChange}
                                              />
                                            </Col>
                                          </>
                                        ) : null}
                                      </Row>
                                    ))}
                                  </CardBody>
                                </Card>
                              ) : null}

                              {investData?.detail_investissement?.[
                                "Description"
                              ] ? (
                                <Card className="mb-4">
                                  <CardTitle
                                    tag="h5"
                                    style={{ paddingLeft: "10px" }}
                                  >
                                    Description
                                  </CardTitle>
                                  <CardBody>
                                    {Object.entries(
                                      investData?.detail_investissement?.[
                                        "Description"
                                      ]
                                    ).map(([key, value], index) => (
                                      <Row className="mb-3" key={index}>
                                        {key == "Désignation courte" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i
                                                style={{
                                                  color: "#9d9c9c",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "8em",
                                                    whiteSpace: "nowrap",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  {key} :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col className="col-8">
                                              <input
                                                className="form-control"
                                                defaultValue={
                                                  selectedDesignationCourte
                                                }
                                                required
                                                onChange={
                                                  handleDesignationCourteChange
                                                }
                                              />
                                            </Col>
                                          </>
                                        ) : key ==
                                          "Désignation de l'opération" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i
                                                style={{
                                                  color: "#9d9c9c",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "8em",
                                                    whiteSpace: "wrap",
                                                  }}
                                                >
                                                  {key}:
                                                </span>
                                              </i>
                                            </Col>
                                            <Col className="col-8">
                                              <input
                                                className="form-control"
                                                defaultValue={
                                                  selectedDesignationOp
                                                }
                                                required
                                                onChange={
                                                  handleDesignationOpChange
                                                }
                                              />
                                            </Col>
                                          </>
                                        ) : key == "Partenaires industriels" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i
                                                style={{
                                                  color: "#9d9c9c",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "8em",
                                                    whiteSpace: "wrap",
                                                  }}
                                                >
                                                  {key}:
                                                </span>
                                              </i>
                                            </Col>
                                            <Col className="col-8">
                                              <Select
                                                defaultValue={
                                                  selectedPartenaireIndu
                                                }
                                                onChange={
                                                  handlePartenaireInduChange
                                                }
                                                options={renderPartenaireInduOptions()}
                                                isClearable={true}
                                                className="select2"
                                              />
                                            </Col>
                                          </>
                                        ) : null}
                                      </Row>
                                    ))}
                                  </CardBody>
                                </Card>
                              ) : null}
                              {investData?.detail_investissement?.[
                                "Description"
                              ] ? (
                                <Card className="mb-4">
                                  <CardTitle
                                    tag="h5"
                                    style={{ paddingLeft: "10px" }}
                                  >
                                    Honoraires
                                  </CardTitle>
                                  <CardBody>
                                    {Object.entries(
                                      investData?.detail_investissement?.[
                                        "Honoraires"
                                      ]
                                    ).map(([key, value], index) => (
                                      <Row className="mb-3" key={index}>
                                        {key == "Honoraire 1" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i
                                                style={{
                                                  color: "#9d9c9c",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "8em",
                                                    whiteSpace: "nowrap",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  {key} :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col className="col-8">
                                              <input
                                                className="form-control"
                                                defaultValue={
                                                  selectedHonoraire1
                                                }
                                                required
                                                onChange={
                                                  handleHonoraire1Change
                                                }
                                              />
                                            </Col>
                                          </>
                                        ) : key == "Honoraire 2" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i
                                                style={{
                                                  color: "#9d9c9c",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "8em",
                                                    whiteSpace: "nowrap",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  {key}:
                                                </span>
                                              </i>
                                            </Col>
                                            <Col className="col-8">
                                              <input
                                                className="form-control"
                                                defaultValue={
                                                  selectedHonoraire2
                                                }
                                                required
                                                onChange={
                                                  handleHonoraire2Change
                                                }
                                              />
                                            </Col>
                                          </>
                                        ) : key == "Honoraire 3" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i
                                                style={{
                                                  color: "#9d9c9c",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "8em",
                                                    whiteSpace: "nowrap",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  {key}:
                                                </span>
                                              </i>
                                            </Col>
                                            <Col className="col-8">
                                              <input
                                                className="form-control"
                                                defaultValue={
                                                  selectedHonoraire3
                                                }
                                                required
                                                onChange={
                                                  handleHonoraire3Change
                                                }
                                              />
                                            </Col>
                                          </>
                                        ) : key == "Taux loyer" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i
                                                style={{
                                                  color: "#9d9c9c",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "8em",
                                                    whiteSpace: "nowrap",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  {key}:
                                                </span>
                                              </i>
                                            </Col>
                                            <Col className="col-8">
                                              <input
                                                className="form-control"
                                                defaultValue={selectedTauxLoyer}
                                                required
                                                onChange={handleTauxLoyerChange}
                                              />
                                            </Col>
                                          </>
                                        ) : key == "Taux service" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i
                                                style={{
                                                  color: "#9d9c9c",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "8em",
                                                    whiteSpace: "nowrap",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  {key}:
                                                </span>
                                              </i>
                                            </Col>
                                            <Col className="col-8">
                                              <input
                                                className="form-control"
                                                defaultValue={
                                                  selectedTauxService
                                                }
                                                required
                                                onChange={
                                                  handleTauxServiceChange
                                                }
                                              />
                                            </Col>
                                          </>
                                        ) : null}
                                      </Row>
                                    ))}
                                  </CardBody>
                                </Card>
                              ) : null}

                              {/* 
                              {investData?.detail_investissement?.[
                                "Tableau des amortissements"
                              ] ? (
                                <Row>
                                  <Col sm="12">
                                    <CardTitle
                                      tag="h5"
                                      style={{ paddingBottom: "10px" }}
                                    >
                                      Tableau des amortissements{" "}
                                    </CardTitle>
                                    <TableComponent
                                      header={
                                        investData?.detail_investissement?.[
                                          "Tableau des amortissements"
                                        ]?.["Tableau amortissements"]?.header
                                      }
                                      data={
                                        investData?.detail_investissement?.[
                                          "Tableau des amortissements"
                                        ]?.["Tableau amortissements"]?.data
                                      }
                                    />
                                  </Col>
                                </Row>
                              ) : null} */}
                            </Col>
                            <Col sm="6">
                              <Row>
                                {investData?.detail_investissement?.[
                                  "Exploitation"
                                ] ? (
                                  <Card className="mb-4">
                                    <CardTitle
                                      tag="h5"
                                      style={{ paddingLeft: "10px" }}
                                    >
                                      Exploitation
                                    </CardTitle>
                                    <CardBody>
                                      {Object.entries(
                                        investData?.detail_investissement?.[
                                          "Exploitation"
                                        ]
                                      ).map(([key, value], index) => (
                                        <Row className="mb-3" key={index}>
                                          {key == "Exploitant" &&
                                          showField?.displayed_fields?.includes(
                                            "partenaire2_id"
                                          ) ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i
                                                  style={{
                                                    color: "#9d9c9c",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "8em",
                                                      whiteSpace: "nowrap",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key} :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="col-8">
                                                <Select
                                                  defaultValue={
                                                    selectedExploitant
                                                  }
                                                  onChange={
                                                    handleExploitantChange
                                                  }
                                                  options={renderExploitantOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                />
                                              </Col>
                                            </>
                                          ) : key == "Section" &&
                                            showField?.displayed_fields?.includes(
                                              "section"
                                            ) ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i
                                                  style={{
                                                    color: "#9d9c9c",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "8em",
                                                      whiteSpace: "nowrap",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key}:
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="col-8">
                                                <input
                                                  className="form-control"
                                                  defaultValue={selectedSection}
                                                  required
                                                  onChange={handleSectionChange}
                                                />
                                              </Col>
                                            </>
                                          ) : key == "N° cadastre" &&
                                            showField?.displayed_fields?.includes(
                                              "n_cadastre"
                                            ) ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i
                                                  style={{
                                                    color: "#9d9c9c",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "8em",
                                                      whiteSpace: "nowrap",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key}:
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="col-8">
                                                <input
                                                  className="form-control"
                                                  defaultValue={
                                                    selectedCadastre
                                                  }
                                                  required
                                                  onChange={
                                                    handleCadastreChange
                                                  }
                                                />
                                              </Col>
                                            </>
                                          ) : key == "Contenance" &&
                                            showField?.displayed_fields?.includes(
                                              "contenance"
                                            ) ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i
                                                  style={{
                                                    color: "#9d9c9c",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "8em",
                                                      whiteSpace: "nowrap",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key}:
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="col-8">
                                                <input
                                                  className="form-control"
                                                  defaultValue={
                                                    selectedContenance
                                                  }
                                                  required
                                                  onChange={
                                                    handleContenanceChange
                                                  }
                                                />
                                              </Col>
                                            </>
                                          ) : key == "Nature" &&
                                            showField?.displayed_fields?.includes(
                                              "nature"
                                            ) ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i
                                                  style={{
                                                    color: "#9d9c9c",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "8em",
                                                      whiteSpace: "nowrap",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key}:
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="col-8">
                                                <input
                                                  className="form-control"
                                                  defaultValue={selectedNature}
                                                  required
                                                  onChange={handleNatureChange}
                                                />
                                              </Col>
                                            </>
                                          ) : key == "Lieu-dit" &&
                                            showField?.displayed_fields?.includes(
                                              "lieudit"
                                            ) ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i
                                                  style={{
                                                    color: "#9d9c9c",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "8em",
                                                      whiteSpace: "nowrap",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key}:
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="col-8">
                                                <input
                                                  className="form-control"
                                                  defaultValue={selectedLieuDit}
                                                  required
                                                  onChange={handleLieuDitChange}
                                                />
                                              </Col>
                                            </>
                                          ) : key == "Adresse" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i
                                                  style={{
                                                    color: "#9d9c9c",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "8em",
                                                      whiteSpace: "nowrap",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key}:
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="col-8">
                                                <input
                                                  className="form-control"
                                                  defaultValue={selectedAdresse}
                                                  required
                                                  onChange={handleAdresseChange}
                                                />
                                              </Col>
                                            </>
                                          ) : key == "CodePostal" &&
                                            showField?.displayed_fields?.includes(
                                              "code_postal"
                                            ) ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i
                                                  style={{
                                                    color: "#9d9c9c",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "8em",
                                                      whiteSpace: "nowrap",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key}:
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="col-8">
                                                <input
                                                  className="form-control"
                                                  defaultValue={
                                                    selectedCodePostal
                                                  }
                                                  required
                                                  onChange={
                                                    handleCodePostalChange
                                                  }
                                                />
                                              </Col>
                                            </>
                                          ) : key == "Commune" &&
                                            showField?.displayed_fields?.includes(
                                              "commune"
                                            ) ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i
                                                  style={{
                                                    color: "#9d9c9c",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "8em",
                                                      whiteSpace: "nowrap",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key}:
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="col-8">
                                                <input
                                                  className="form-control"
                                                  defaultValue={selectedCommune}
                                                  required
                                                  onChange={handleCommuneChange}
                                                />
                                              </Col>
                                            </>
                                          ) : key == "Date PV livraison" &&
                                            showField?.displayed_fields?.includes(
                                              "date_pv_livraison"
                                            ) ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i
                                                  style={{
                                                    color: "#9d9c9c",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "8em",
                                                      whiteSpace: "nowrap",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key}:
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="col-8">
                                                <input
                                                  className="form-control"
                                                  defaultValue={
                                                    selectedDateLivraison
                                                  }
                                                  required
                                                  onChange={
                                                    handleDateLivraisonChange
                                                  }
                                                />
                                              </Col>
                                            </>
                                          ) : key == "Montant (€)" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i
                                                  style={{
                                                    color: "#9d9c9c",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "8em",
                                                      whiteSpace: "nowrap",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key}:
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="col-8">
                                                <input
                                                  className="form-control"
                                                  defaultValue={selectedMontant}
                                                  required
                                                  onChange={handleMontantChange}
                                                />
                                              </Col>
                                            </>
                                          ) : key == "Prix unitaire (€)" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i
                                                  style={{
                                                    color: "#9d9c9c",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "8em",
                                                      whiteSpace: "nowrap",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key}:
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="col-8">
                                                <input
                                                  className="form-control"
                                                  defaultValue={
                                                    selectedPrixUnitaire
                                                  }
                                                  required
                                                  onChange={
                                                    handlePrixUnitaireChange
                                                  }
                                                />
                                              </Col>
                                            </>
                                          ) : key ==
                                              "% rétrocession exploitant" &&
                                            showField?.displayed_fields?.includes(
                                              "pourc_retrocession_exploitant"
                                            ) ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i
                                                  style={{
                                                    color: "#9d9c9c",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "8em",
                                                      whiteSpace: "wrap",
                                                    }}
                                                  >
                                                    {key}:
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="col-8">
                                                <input
                                                  className="form-control"
                                                  defaultValue={
                                                    selectedPourcentageRetro
                                                  }
                                                  required
                                                  onChange={
                                                    handlePourcentageRetroChange
                                                  }
                                                />
                                              </Col>
                                            </>
                                          ) : key ==
                                            "Rétrocession exploitant (€)" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i
                                                  style={{
                                                    color: "#9d9c9c",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "8em",
                                                      whiteSpace: "wrap",
                                                    }}
                                                  >
                                                    {key}:
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="col-8">
                                                <input
                                                  className="form-control"
                                                  defaultValue={
                                                    selectedRetroExploitant
                                                  }
                                                  required
                                                  onChange={
                                                    handleRetroExploitantChange
                                                  }
                                                />
                                              </Col>
                                            </>
                                          ) : key ==
                                              "Durée amortissement (mois)" &&
                                            showField?.displayed_fields?.includes(
                                              "duree_amortissement"
                                            ) ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i
                                                  style={{
                                                    color: "#9d9c9c",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "8em",
                                                      whiteSpace: "wrap",
                                                    }}
                                                  >
                                                    {key}:
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="col-8">
                                                <input
                                                  className="form-control"
                                                  defaultValue={
                                                    selectedDureeAmortissement
                                                  }
                                                  required
                                                  onChange={
                                                    handleDureeAmortissementChange
                                                  }
                                                />
                                              </Col>
                                            </>
                                          ) : key == "Agrément" &&
                                            showField?.displayed_fields?.includes(
                                              "agrement"
                                            ) ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i
                                                  style={{
                                                    color: "#9d9c9c",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "8em",
                                                      whiteSpace: "nowrap",
                                                      paddingTop: 10,
                                                    }}
                                                  >
                                                    {key}:
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="col-8">
                                                <Select
                                                  defaultValue={
                                                    selectedPartenaireIndu
                                                  }
                                                  onChange={
                                                    handlePartenaireInduChange
                                                  }
                                                  options={renderOuiNonOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                />
                                              </Col>
                                            </>
                                          ) : key == "Subvention" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i
                                                  style={{
                                                    color: "#9d9c9c",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "8em",
                                                      whiteSpace: "nowrap",
                                                      paddingTop: 10,
                                                    }}
                                                  >
                                                    {key}:
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="col-8">
                                                <Select
                                                  defaultValue={
                                                    selectedSubvention
                                                  }
                                                  onChange={
                                                    handleSubventionChange
                                                  }
                                                  options={renderOuiNonOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                />
                                              </Col>
                                            </>
                                          ) : key == "Base éligible (€)" &&
                                            showField?.displayed_fields?.includes(
                                              "base_eligible_investissment"
                                            ) ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i
                                                  style={{
                                                    color: "#9d9c9c",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "8em",
                                                      whiteSpace: "nowrap",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key}:
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="col-8">
                                                <input
                                                  className="form-control"
                                                  defaultValue={
                                                    selectedBaseEligible
                                                  }
                                                  required
                                                  onChange={
                                                    handleBaseEligibleChange
                                                  }
                                                />
                                              </Col>
                                            </>
                                          ) : key == "Réduction impôt (€)" &&
                                            showField?.displayed_fields?.includes(
                                              "reduction_impot"
                                            ) ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i
                                                  style={{
                                                    color: "#9d9c9c",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "8em",
                                                      whiteSpace: "nowrap",
                                                      paddingTop: "10px",
                                                    }}
                                                  >
                                                    {key}:
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="col-8">
                                                <input
                                                  className="form-control"
                                                  defaultValue={
                                                    selectedReductionImpot
                                                  }
                                                  required
                                                  onChange={
                                                    handleReductionImpotChange
                                                  }
                                                />
                                              </Col>
                                            </>
                                          ) : null}
                                        </Row>
                                      ))}
                                    </CardBody>
                                  </Card>
                                ) : null}
                              </Row>
                            </Col>{" "}
                            {/*
                                {investData?.detail_investissement?.Loyers ? (
                                  <Row>
                                    <Col sm="12">
                                      <CardTitle
                                        tag="h5"
                                        style={{ paddingBottom: "10px" }}
                                      >
                                        Loyers{" "}
                                      </CardTitle>
                                      <TableComponent
                                        header={
                                          investData?.detail_investissement
                                            ?.Loyers["Loyers investissement"]
                                            ?.header
                                        }
                                        data={
                                          investData?.detail_investissement
                                            ?.Loyers["Loyers investissement"]
                                            ?.data
                                        }
                                      />
                                    </Col>
                                  </Row>
                                ) : null}
                                {investData?.detail_investissement?.Audit ? (
                                  <SectionCard
                                    title="Audit"
                                    details={
                                      investData?.detail_investissement?.Audit
                                    }
                                  />
                                ) : null}
                              </Row>
                            </Col>

                            <>
                              {investData?.detail_pme?.documents.map(
                                (section, index) => (
                                  <Col
                                    sm={Math.min(
                                      Math.floor(
                                        12 /
                                          investData?.detail_pme?.documents
                                            .length
                                      ),
                                      12
                                    )}
                                  >
                                    <Row>
                                      <Card key={`section_${index}`}>
                                        <CardBody>
                                          <CardTitle
                                            className="mb-3"
                                            style={{ whiteSpace: "pretty" }}
                                          >
                                            {section.section_name}
                                          </CardTitle>

                                          {section.data.map((file, i) => (
                                            <Row
                                              key={`_file_${i}`}
                                              style={{
                                                borderBottom: "1px solid #eee",
                                                padding: "10px 0",
                                              }}
                                            >
                                              <Col
                                                xs={2}
                                                style={{ display: "" }}
                                              >
                                                <div className="avatar-sm">
                                                  <span className="avatar-title rounded-circle bg-primary-subtle text-primary font-size-24">
                                                    <i className="bx bxs-file-doc" />
                                                  </span>
                                                </div>
                                              </Col>
                                              <Col
                                                xs={8}
                                                style={{
                                                  display: "inline-block",
                                                }}
                                              >
                                                <a
                                                  href={`https://www.fluxod.com/${api}/${
                                                    file?.link?.controller
                                                  }/${file?.link?.action}&${
                                                    Object.keys(
                                                      file.link.params
                                                    )[0]
                                                  }=${
                                                    file?.link?.params?.[
                                                      Object.keys(
                                                        file.link.params
                                                      )[0]
                                                    ]
                                                  }`}
                                                  className="text-dark"
                                                  style={{
                                                    textDecoration: "none",
                                                    display: "block",
                                                  }}
                                                >
                                                  <h5
                                                    className="font-size-14 mb-1"
                                                    style={{ paddingLeft: 10 }}
                                                  >
                                                    {file.nom}
                                                  </h5>
                                                  <small
                                                    style={{ paddingLeft: 10 }}
                                                  >
                                                    {file.type}
                                                  </small>
                                                </a>
                                              </Col>
                                              <Col xs={2}>
                                                <div
                                                  style={{
                                                    display: "inline-block",
                                                  }}
                                                >
                                                  {file.link && (
                                                    <a
                                                      href={`https://www.fluxod.com/${api}/${
                                                        file?.link?.controller
                                                      }/${file?.link?.action}&${
                                                        Object.keys(
                                                          file.link.params
                                                        )[0]
                                                      }=${
                                                        file?.link?.params?.[
                                                          Object.keys(
                                                            file.link.params
                                                          )[0]
                                                        ]
                                                      }`}
                                                      className="text-dark"
                                                    >
                                                      <i className="bx bx-download h3 m-0" />
                                                    </a>
                                                  )}
                                                </div>
                                              </Col>
                                            </Row>
                                          ))}
                                        </CardBody>
                                      </Card>
                                    </Row>
                                  </Col>
                                )
                              )}
                            </> */}
                            <Col sm="12">{/*  */}</Col>
                          </Row>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} setWait={wait} />
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
};

export default investissEdit;
